export const REVIEWS_DATA_PERIOD = {
  DAY: "day",
  WEEK: "week",
  MONTH: "month"
};
